<template>
  <el-dialog
    v-model="isShowNftZoomModal"
    :append-to-body="isMobile"
    :center="true"
    class="nft-zoom-box"
    modal-class="transparent-overlay"
  >
    <div
      class="recipe-name"
      :style="$i18n.locale === 'ru' ? { fontFamily: `'PT Serif', sans-serif` } : { fontFamily: 'Grenze, sans-serif' }"
    >
      {{ nftName }}
    </div>
    <div class="zoomed-box">
      <img :src="props.src" alt="nft" />
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
const props = defineProps<{ src: string; nftName: string }>();
const { isMobile } = useDevice();
const isShowNftZoomModal = defineModel<boolean>();
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1;
  height: auto;
  object-fit: contain;
  border-radius: 24px;

  @media screen and (max-width: 479px) {
    width: 100%;
    border-radius: 22px;
    max-width: 320px;
  }
}

.recipe-name {
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  color: #88e1ff;
  text-align: center;
  padding-bottom: 16px;
  width: 80%;
  margin: 24px auto 0;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.zoomed-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.transparent-overlay {
  background-color: transparent;
}

.el-dialog.nft-zoom-box {
  background: radial-gradient(circle at 50% 30%, #0083ad 0%, transparent 100%),
    linear-gradient(180deg, #0d242f 0%, #0d242f 100%);
  padding: 16px;

  width: 440px;
  max-width: calc(100% - 32px);

  @media screen and (max-width: 479px) {
    min-height: auto;
    width: 343px;
  }
}

.el-dialog--center.nft-zoom-box {
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
}
</style>
